import { Visualizer } from '@urbanmix-tech/um-embedded';
import { LegendConfig } from './BuildingLegend';

/**
 * Adds legend configuration to a visualizer instance
 * This allows visualizers to carry their legend display metadata
 *
 * @example
 * const visualizer = new ColorGradeVisualizer(...);
 * withLegendConfig(visualizer, {
 *   legendTitle: 'PPSQF',
 *   dataType: 'currency',
 *   precision: 2,
 *   suffix: ' per sqft'
 * });
 */
export function withLegendConfig(
  visualizer: Visualizer,
  config: LegendConfig
): Visualizer & { legendConfig?: LegendConfig } {
  const vis = visualizer as any;
  vis.legendConfig = config;
  return vis;
}

/**
 * Gets the legend configuration from a visualizer
 * Returns undefined if no configuration was set
 */
export function getLegendConfig(visualizer: Visualizer): LegendConfig | undefined {
  const vis = visualizer as any;
  return vis.legendConfig;
}

/**
 * Common legend configurations for quick use
 */
export const commonLegendConfigs = {
  ppsqf: {
    legendTitle: 'Eff. Annual Rent/Sqft',
    dataType: 'currency' as const,
    precision: 1,
    currencySymbol: '$',
    suffix: '',
  },

  rent: {
    legendTitle: 'RENT',
    dataType: 'currency' as const,
    precision: 0,
    currencySymbol: '$',
  },

  days: {
    legendTitle: 'DAYS',
    dataType: 'number' as const,
    precision: 0,
    suffix: ' days',
  },

  percentage: {
    legendTitle: 'PERCENTAGE',
    dataType: 'percentage' as const,
    precision: 1,
  },

  status: {
    legendTitle: 'STATUS',
    dataType: 'text' as const,
  },

  leaseStatus: {
    legendTitle: 'LEASE STATUS',
    dataType: 'text' as const,
  },
};
